export const initialMetricsReportSubscriptionsState = {
    subscriptionsById: {},
    subscriptionIds: {},
};
